(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sparkly-awareness-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sparkly-awareness-card')) {
  customElements.define('sparkly-awareness-card', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.photos = JSON.parse(this.querySelector('[data-photos]').textContent);
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.styleSelect = this.querySelector('[data-style]');
      this.colorSelect = this.querySelector('[data-color]');
      this.sizeSelect = this.querySelector('[data-size]');
      this.image = this.querySelector('img');
      this.shopLink = this.querySelector('[data-shop]');
      this.baseUrl = this.shopLink?.getAttribute('href');
      this.addEventListener('change', () => {
        this.stopHover();
        this.update();
      });
      const photo = this.querySelector('.sparkly-awareness__photo');
      photo.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse' || !matchMedia('(hover: hover)').matches || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        let index = Array.from(this.colorSelect.options).findIndex(option => option.value === this.colorSelect.value);
        this.stopHover();
        const advance = () => {
          index = (index + 1) % this.colorSelect.options.length;
          this.showPhoto(this.colorSelect.options[index].value);
        };
        advance();
        this.hoverTimer = setInterval(advance, 1200);
      });
      photo.addEventListener('pointerleave', () => {
        this.stopHover();
        this.showPhoto(this.colorSelect.value);
      });
      this.update();
    }
    disconnectedCallback() { this.stopHover(); }
    stopHover() { clearInterval(this.hoverTimer); }
    showPhoto(color) {
      const photo = this.photos.find(photo => photo.style === this.styleSelect.value && photo.color === color);
      if (!photo?.url || !this.image) return;
      this.image.removeAttribute('srcset');
      this.image.src = photo.url;
      this.image.alt = this.dataset.title + ' — ' + this.styleSelect.value + ' — ' + color;
    }
    update() {
      const style = this.styleSelect.value;
      for (const option of this.sizeSelect.options) {
        const invalid = style !== 'Tee' && ['4X','5X'].includes(option.value);
        option.hidden = invalid;
        option.disabled = invalid;
      }
      if (this.sizeSelect.selectedOptions[0]?.disabled) this.sizeSelect.value = '3X';
      const size = this.sizeSelect.value;
      const price = style === 'Tee' ? (['S','M','L','XL'].includes(size) ? 25 : size === '2X' ? 28 : 30) : style === 'Crewneck' ? (size === '3X' ? 40 : 32) : (['S','M','L','XL'].includes(size) ? 40 : size === '2X' ? 45 : 47);
      this.querySelector('.sparkly-awareness__price').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:'USD'}).format(price);
      this.showPhoto(this.colorSelect.value);
      const variant = this.variants.find(variant => variant.option1 === style && variant.option2 === this.colorSelect.value && variant.option3 === size);
      if (this.shopLink && variant) this.shopLink.href = this.baseUrl + '?variant=' + variant.id;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sparkly-fall-mockups"] && !Shopify.designMode) return;
  try {
    
function setupFallViewers() {
  document.querySelectorAll('[data-color-viewer]').forEach(viewer => {
    if (viewer.dataset.ready) return;
    viewer.dataset.ready = 'true';
    const slides = [...viewer.querySelectorAll('.fall-gallery__slide')];
    const choices = [...viewer.querySelectorAll('[data-color-index]')];
    const media = viewer.querySelector('.fall-gallery__media');
    let current = 0;
    let timer;
    const show = index => {
      current = index % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
      choices.forEach((choice, i) => choice.setAttribute('aria-pressed', String(i === current)));
    };
    const stop = () => { clearInterval(timer); timer = undefined; };
    viewer.addEventListener('pointerenter', event => {
      if (event.pointerType !== 'mouse') return;
      stop();
      show(current + 1);
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(() => show(current + 1), 1500);
    });
    viewer.addEventListener('pointerleave', event => {
      if (event.pointerType !== 'mouse') return;
      stop();
      show(0);
    });
    media.addEventListener('click', () => { stop(); show(current + 1); });
    choices.forEach(choice => choice.addEventListener('click', () => { stop(); show(Number(choice.dataset.colorIndex)); }));
  });
}
setupFallViewers();
document.addEventListener('shopify:section:load', setupFallViewers);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sparkly-welcome-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sparkly-welcome')) {
    customElements.define('sparkly-welcome', class extends HTMLElement {
      connectedCallback() {
        const dialog = this.querySelector('dialog');
        if (!dialog || this.bound) return;
        this.bound = true;
        const storageKey = 'sparkly-welcome-launch-2026';
        const now = Date.now();
        const starts = Date.parse(this.dataset.start);
        const ends = Date.parse(this.dataset.end);
        const editor = this.dataset.preview === 'true';
        if (now > ends && !editor) { this.hidden = true; return; }
        const open = () => { if (!dialog.open) dialog.showModal(); };
        const remember = () => { try { localStorage.setItem(storageKey, 'dismissed'); } catch {} };
        const close = () => { remember(); dialog.close(); };
        this.querySelector('[data-welcome-open]').addEventListener('click', open);
        this.querySelector('[data-welcome-close]').addEventListener('click', close);
        dialog.addEventListener('cancel', remember);
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
        });
        if (this.querySelector('[data-welcome-success], [data-welcome-error]')) { open(); remember(); return; }
        let dismissed = false;
        try { dismissed = localStorage.getItem(storageKey) === 'dismissed'; } catch {}
        if (now >= starts && now <= ends && !dismissed && !editor) {
          const tryOpen = (attempts = 0) => {
            if (!this.isConnected || Date.now() > ends) return;
            const consent = document.querySelector('#shopify-pc__banner');
            if (consent && consent.getBoundingClientRect().height > 0) {
              if (attempts < 24) this.timer = setTimeout(() => tryOpen(attempts + 1), 5000);
              return;
            }
            open();
          };
          this.timer = setTimeout(() => tryOpen(), 8000);
        }
      }
      disconnectedCallback() { clearTimeout(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
